export function formatLeverage(leverage: number) {
  // If there's a decimal part, use toFixed(1), otherwise, show it without decimals.
  if (Number.isInteger(leverage)) {
    return leverage?.toFixed(0); // No decimals for integers
  } else {
    return leverage?.toFixed(1); // Round to 1 decimal place
  }
}
